import { CropYear } from "../cropYear"
import { ICropping } from "../fields"
import { isArray, isDate } from "../utils/utils"
import { checkPerennialSequence } from "./autohistory"

type Sequence = { previous: ICropping[], next: ICropping[] }

export function getPerennialDatesInYear(crop: ICropping, sequence?: Sequence) {

    const yearStart = CropYear.getYearStart(crop.YearId)
    const yearEnd = CropYear.getYearEnd(crop.YearId)

    function inYear(d: Date) {
        return isDate(d) && (d.valueOf() >= yearStart.valueOf()) && (d.valueOf() <= yearEnd.valueOf())
    }

    function checkSequence(rel: (i: Sequence) => ICropping[], yearOffset: 1 | -1) {

        if (!sequence) return false

        const s = rel(sequence)

        const single = isArray(s) && s.length == 1 ? s[0] : undefined
        if (!single) return true

        return (single.Crop != crop.Crop) || ((single.YearId + yearOffset) != crop.YearId) || (single.Area != crop.Area)

    }

    const start = crop.SowingDate || crop.StartDate
    const end = crop.DestructionDate

    const dates = {
        start: inYear(start) || checkSequence(r => r.previous, -1) ? start : yearStart,
        end: inYear(end) || checkSequence(r => r.next, 1) ? (end || yearEnd) : yearEnd
    }

    return dates

}

export function getPerennialSequence(from: ICropping) {

    const getSequence = (rel: (s: ICropping) => ICropping[], sequence: ICropping[]): ICropping[] => {

        const current = sequence[sequence.length - 1]
        const next = rel(current)

        if (checkPerennialSequence(current, next, getPerennialCroppingInfo)) {
            return getSequence(rel, sequence.concat(next))
        }

        return sequence

    }

    if (from.Crop && from.Crop.Perennial) {

        const prev = getSequence(c => c.PreviousCroppings, [from])
        const next = getSequence(c => c.NextCroppings, [from])

        const sequence = prev.concat(next.slice(1)).sort((a, b) => a.YearId - b.YearId)

        return sequence

    }


}

export const getPerennialCroppingInfo = (c: ICropping) => ({
    cropId: c.CropId,
    year: c.YearId,
    startDate: c.StartDate,
    endDate: c.EndDate,
    destroyed: !!c.DestructionDate
})
